/**
 * Comparing the titles a crawled site gave its own pages, to spot two pages
 * that are really the same page.
 *
 * These titles are someone else's text, so all of the normalising and the
 * word-overlap scoring happens here and the map gets a number back. The
 * generic-title pattern names mastheads that every page on a news site
 * repeats — matching them would report the whole estate as duplicated.
 */

const GENERIC_TITLE =
  /breaking news.*latest news.*business.*sport|latest news.*business.*sport.*entertainment/i;

/** A masthead-style title that says nothing about the page it is on. */
export function readsAsGenericTitle(title: string): boolean {
  return GENERIC_TITLE.test(title);
}

/** How much two titles have in common: shared distinctive words, and a ratio. */
export function titleSimilarity(
  left: string,
  right: string,
): { shared: number; ratio: number } {
  const leftWords = new Set(normalisedTitle(left).split(" ").filter(Boolean));
  const rightWords = new Set(normalisedTitle(right).split(" ").filter(Boolean));
  const shared = [...leftWords].filter((word) => rightWords.has(word)).length;
  return {
    shared,
    ratio: shared / Math.max(leftWords.size, rightWords.size, 1),
  };
}

/** One spelling per title: lowercase, letters and digits only. */
export function normalisedTitle(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();
}
